/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string,
} from 'prop-types';
import { isEmpty } from '../../../utils/object';

const GiftMessage = ({ ROSSItem }) => {
   return !isEmpty(ROSSItem) ? (
      <div>
            <h2 className="gray-color">
               <div className="split align-center">
                  <div className="align-left">Gift Message</div>
               </div>
            </h2>
            <div className="gift-message-container">{ROSSItem?.cardMessage || 'No Card Message'}</div>
      </div>
   ) : (
      <div>
            <h2 className="gray-color">
               <div className="split align-center">
                  <div className="align-left">Gift Message</div>
               </div>
            </h2>
            <div className="gift-message-container">{'No Card Message'}</div>
      </div>
   );
}

GiftMessage.defaultProps = {
    ROSSItem: {},
};

GiftMessage.propTypes = {
    ROSSItem: shape({
        cardMessage: string.isRequired,
    }),
};

export default GiftMessage;
